const STORAGE_KEY = "hg-processing-documents";

export interface ProcessingDocument {
  documentId: string;
  agentId?: string;
  startedAt: number;
}

export const processingDocumentsStorage = {
  add: (document: ProcessingDocument) => {
    const docs = processingDocumentsStorage.getAll();
    const exists = docs.some((d) => d.documentId === document.documentId && d.agentId === document.agentId);
    if (!exists) {
      docs.push(document);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(docs));
    }
  },

  remove: (documentId: string, agentId?: string) => {
    const docs = processingDocumentsStorage.getAll();
    const filtered = docs.filter((d) => !(d.documentId === documentId && d.agentId === agentId));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  },

  getAll: (): ProcessingDocument[] => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },

  getByAgentId: (agentId: string): ProcessingDocument[] => {
    return processingDocumentsStorage.getAll().filter((d) => d.agentId === agentId);
  },

  clear: () => {
    localStorage.removeItem(STORAGE_KEY);
  },
};
